var angular = require('angular');
var _module = require('./index');
const _ = require('lodash');

require('../core/utils');
require('../events');

_module.directive('counterpartInfo', [function() {
    return {
        restrict: 'E',
        templateUrl: 'js/components/modals/templates/counterpart-info.tmpl.html',
        scope: {
            counterpart: '=',
            report: '=',
            showListingFeature: '='
        },
        bindToController: true,
        controllerAs: 'vm',
        controller: [
            function() {
                var vm = this;
                const meta = _.get(vm, 'report.meta.Listhub.Agent') || {};
                const verifiedListingAgent = _.get(vm, 'report.verified_listing_agent') || {};

                vm.listingAgentInfo = {
                    name: meta.Name || verifiedListingAgent.name,
                    first_name: meta.FirstName || verifiedListingAgent.first_name,
                    last_name: meta.LastName || verifiedListingAgent.last_name,
                    company: meta.Company || verifiedListingAgent.company,
                    phone: meta.Phone || verifiedListingAgent.phone,
                    email: meta.Email || verifiedListingAgent.email,
                    website: meta.website || verifiedListingAgent.website,
                };
            }
        ]
    };
}]);
